import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=5f9a3ca8&scoped=true"
import script from "./AppSearch.vue?vue&type=script&lang=js"
export * from "./AppSearch.vue?vue&type=script&lang=js"
import style0 from "./AppSearch.vue?vue&type=style&index=0&id=5f9a3ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a3ca8",
  null
  
)

export default component.exports